








































































































































































































































































































import { Component, Prop, Vue, Inject } from "vue-property-decorator";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

import MainDemo from "../../demo/main-demo.vue";
import WikiPreviewDemo from "../../demo/wiki/wiki-preview-demo.vue";
import WikiMapDemo from "../../demo/wiki/wiki-map-demo.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import { Hooper, Slide } from "hooper";
import { IWikiObject } from "@/@types/wiki/wiki-object";
import { preferred_language } from "@/config/languags.config.json";
import "hooper/dist/hooper.css";
import { ILocale } from "@/@types/locale";

@Component({
  components: {
    StandartModal,
    controls: ChangeDeliteButtons,
    BSwitch,
    MainDemo,
    WikiPreviewDemo,
    WikiMapDemo,
    LanguagesButtons,
    Hooper,
    Slide,
  },
})
class WikiObjectCard extends Vue {
  @Prop({ type: Object, default: null }) wiki!: IWikiObject;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<IWikiObject>;

  @Inject({ from: "bgFolder", default: null }) readonly bgFolder!: string;
  @Inject({ from: "posterFolder", default: null }) readonly folder!: string;
  @Inject({ from: "galleryFolder", default: null }) readonly gFolder!: string;
  @Inject({ from: "categoryFolder", default: null }) readonly cFolder!: string;

  locale = preferred_language;
  onerror = `this.onerror=null; this.src='${this.$getImage(
    "empty.png",
    null
  )}';`;

  get categoryIcon(): string {
    const cat = this.categorys.find((el) => el._id == this.wiki.category);
    return cat?.src?.icon ? cat.src.icon : "";
  }

  get categoryName(): ILocale {
    const cat = this.categorys.find((el) => el._id == this.wiki.category);
    return cat ? cat.name : {};
  }
}
export default WikiObjectCard;
